import React from "react";
import "./SelectableCardGrid.css";

export interface SelectableCardOption<T = string> {
  id: T;
  label: string;
  icon?: React.ReactNode;
  image?: string;
  imageAlt?: string;
}

export interface SelectableCardGridProps<T = string> {
  options: SelectableCardOption<T>[];
  selectedValue: T | null;
  onChange: (value: T) => void;
  disabled?: boolean;
  columns?: number;
  className?: string;
}

const SelectableCardGrid = <T extends string | number>({
  options,
  selectedValue,
  onChange,
  disabled = false,
  columns = 4,
  className = "",
}: SelectableCardGridProps<T>) => {
  return (
    <div
      className={`selectable-card-grid ${className}`}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {options.map((option) => {
        const isSelected = selectedValue === option.id;
        return (
          <button
            key={String(option.id)}
            type="button"
            className={`selectable-card-grid-card ${isSelected ? "selected" : ""}`}
            onClick={() => onChange(option.id)}
            disabled={disabled}
          >
            {isSelected ? (
              <div className="selectable-card-grid-check">
                <svg width="12" height="12" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="10" fill="#0F5CCD" />
                  <path d="M6 10L9 13L14 7" stroke="white" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
            ) : (
              <div className="selectable-card-grid-radio" />
            )}
            <div className="selectable-card-grid-content">
              {option.image ? (
                <img src={option.image} alt={option.imageAlt || option.label} className="selectable-card-grid-icon" />
              ) : (
                option.icon && <div className="selectable-card-grid-icon-wrapper">{option.icon}</div>
              )}
              <span>{option.label}</span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default SelectableCardGrid;
